import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const services = [
  {
    title: "Lawn mowing & edging",
    desc: "Regular cutting, edging and striping to keep lawns healthy and pristine.",
    img: "/jobs/job-1271.jpeg",
    span: "md:col-span-8",
  },
  {
    title: "Hedge trimming & pruning",
    desc: "Clean, shaped hedges and borders, cut back and cleared away.",
    img: "/jobs/job-1270.jpeg",
    span: "md:col-span-4",
  },
  {
    title: "Weed control & treatment",
    desc: "Targeted treatment to keep paths, beds and driveways weed-free.",
    img: "/jobs/job-1265.webp",
    span: "md:col-span-4",
  },
  {
    title: "Leaf & debris clearance",
    desc: "Overgrown gardens and fallen leaves cleared, tidied and hauled away.",
    img: "/jobs/job-1267.webp",
    span: "md:col-span-4",
  },
  {
    title: "Soft landscaping",
    desc: "Planting, beds and finishing touches that bring outdoor spaces to life.",
    img: "/jobs/job-1269.webp",
    span: "md:col-span-4",
  },
  {
    title: "Seasonal tidy-ups",
    desc: "Year-round upkeep and one-off tidy-ups to keep grounds sharp every season.",
    img: "/jobs/job-1275.webp",
    span: "md:col-span-6",
  },
  {
    title: "Regular maintenance plans",
    desc: "Tailored weekly, fortnightly or monthly visits so you never have to think about it.",
    img: "/jobs/job-1272.jpeg",
    span: "md:col-span-6",
  },
];

const card = {
  hidden: { opacity: 0, y: 50 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const Services = () => {
  return (
    <section id="services" className="relative bg-brand-ink py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-brand-orange" />
              <span className="text-xs md:text-sm tracking-[0.25em] uppercase font-heading text-brand-orange">
                What we do
              </span>
            </div>
            <h2 className="font-heading font-medium tracking-tight text-white text-4xl md:text-6xl leading-[1.05]">
              Services built around <br className="hidden md:block" />your grounds.
            </h2>
          </div>
          <p className="text-white/60 font-body max-w-sm">
            Choose a single service or a full maintenance package. Every job finished to a
            professional standard.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {services.map((s, i) => (
            <motion.button
              key={s.title}
              data-testid={`service-card-${i}`}
              variants={card}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: (i % 3) * 0.08 }}
              onClick={() => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" })}
              className={`group relative overflow-hidden text-left min-h-[320px] md:min-h-[360px] border border-white/10 ${s.span}`}
            >
              <img
                src={s.img}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/10 group-hover:from-black/95 transition-colors" />
              <div className="absolute inset-0 ring-0 group-hover:ring-2 ring-inset ring-brand-orange transition-all" />
              <div className="relative h-full flex flex-col justify-end p-7">
                <div className="flex items-start justify-between">
                  <h3 className="font-heading text-white text-2xl md:text-3xl">{s.title}</h3>
                  <ArrowUpRight
                    size={26}
                    className="text-brand-orange opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
                  />
                </div>
                <p className="text-white/70 font-body mt-3 max-w-md">{s.desc}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
